module.exports = __webpack_public_path__ + "img/logos_customer_14.2a794abd.svg";